var s2 = "/static/e9f5be96c67b48f3.png";

export { s2 as default };
//# sourceMappingURL=s_2.png.js.map
